import classNames from 'classnames';
import React from 'react';

import { FocusContainer } from '@eika/focus-container';

import useFocusContext from '../../NettbankCreateTransactions/hooks/useFocusContext';

type FocusSubModalProps = {
    open?: boolean;
    onClose?: () => void;
    className?: string;
} & React.PropsWithChildren;

const FocusSubModal: React.FC<FocusSubModalProps> = ({ children, open = false, onClose = () => null, className }) => {
    const {
        active: { value: active },
    } = useFocusContext();
    return (
        <FocusContainer entry={open} onExit={onClose}>
            {active && open && (
                <section
                    className={classNames('sub-focus-modal', { active }, className)}
                    role="dialog"
                    aria-modal="true"
                >
                    {children}
                </section>
            )}
        </FocusContainer>
    );
};

export default FocusSubModal;
